import {
  Card,
  Title,
  Text,
  LoadingOverlay,
  Progress,
  Stack,
  Group,
  useMantineTheme,
} from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { ICourse } from '../../../interfaces/ICourse';

export function MasterProgress() {
  const theme = useMantineTheme();

  const { data, loading } = useFetch<{ data: ICourse[] }>(
    `${import.meta.env.VITE_API_URL}/services/userCourses`,
    {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    }
  );

  const allCourses = data?.data || [];

  const calculateMasterProgress = () => {
    const totalCourses = allCourses.length;
    if (totalCourses === 0) return 0;

    const totalProgress = allCourses.reduce((acc, course) => {
      const p = Number(course.progress_percentage ?? 0);
      return acc + p;
    }, 0);

    return Math.round(totalProgress / totalCourses);
  };

  const masterProgress = calculateMasterProgress();

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='xs'>
        Progresso Master
      </Title>
      <LoadingOverlay visible={loading} />
      <Stack gap='xs'>
        <Progress.Root size='md'>
          <Progress.Section value={masterProgress} c={theme.primaryColor} />
        </Progress.Root>
        <Group w='100%' justify='space-between'>
          <Text size='sm' c='dimmed' ta='center'>
            {masterProgress}% completato
          </Text>
          <Text size='xs' c='dimmed' ta='center'>
            Calcolato su {allCourses.length} corsi totali
          </Text>
        </Group>
      </Stack>
    </Card>
  );
}
